import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * ENCAMINHAMENTOS DO ESTUDANTE — migração de `MenuAcademico/CadastrarEncaminhamento.aspx`.
 *
 * Os dois relatórios que no legado tinham uma tela SÓ para imprimir (`EmitirEncaminhamento.aspx`,
 * o acompanhamento por período) e o cadastro dos tipos (`TipoEncaminhamento.aspx`) vivem aqui
 * dentro, como botões/modais — não há tela nova para nenhum dos dois.
 *
 * Permissão PRÓPRIA (300100599), vizinha da legada (300100550).
 */
export default [
  {
    description: 'Encaminhamentos',
    path: '/academico/encaminhamentos',
    name: 'encaminhamentos',
    component: () => import('@/views/academico/encaminhamentos/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ENCAMINHAMENTOSNOVO_MENU_300100599],
    },
    goesToMenu: true,
  },
  {
    description: 'Encaminhamento',
    path: '/academico/encaminhamentos/cadastro/:id?',
    parent: 'encaminhamentos',
    name: 'encaminhamentos_cadastro',
    component: () => import('@/views/academico/encaminhamentos/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.ENCAMINHAMENTOSNOVO_MENU_300100599],
    },
  },
];
